export const MAINTENANCE_IS_RUNNING_KEY = 'ServerMaintenanceIsRunning';
export const MAINTENANCE_DATE_TIME_KEY = 'ServerMaintenanceDateTimeUtc';
export const MAINTENANCE_MODAL_WARNING_KEY = 'maintenanceWarningDisplayed';

export const MAINTENANCE_COOKIES_CHANGED = 'MAINTENANCE_COOKIES_CHANGED';
